export const VIEWPORT = {
    MOBILE: 'mobile',
    DESKTOP: 'desktop',
};

export const SUPPLIER_SWITCH = {
    MAX_DEFAULT_SUPPLIERS: 5,
};
